import { client } from "../client";
import { SavedFile } from "../types/files.types";
import { Ticket } from "../types/ticket.types";
import { createFile } from "./file.mutations";

export const createTicket = async ({ centerId, ...ticket }: { centerId: number | undefined } & Partial<Ticket> ) => {
  // 1. Upload files
  let files: SavedFile[] = []
  if (ticket.files) {
    files = await Promise.all(ticket.files.map((file) => createFile({ file: file as File, fileName: undefined })))
  }
  // 2. Create ticket
  const response = await client.post<Ticket>(`tickets/`, {
    ...ticket,
    centerId,
    files: files.map(file => file.id)
  });
  return response.data
}

export const updateTicket = async (ticket: Pick<Ticket, 'id'> & Partial<Ticket>) => {
  // 1. Upload files
  let files: SavedFile[] = []
  if (ticket.files) {
    files = await Promise.all(ticket.files.map((file) => createFile({ file: file as File, fileName: undefined })))
  }
  // 2. Create ticket
  const response = await client.patch<Ticket>(`tickets/${ticket.id}`, {
    ...ticket,
    files: files.map(file => file.id)
  });
  return response.data
}

export const linkFilesToTicket = async ({ id, fileList }: {id: number, fileList: FileList}) => {
  // 1. Upload files
  const files: SavedFile[] = await Promise.all(Array.from(fileList).map((file) => createFile({ file: file as File, fileName: undefined })))
  // 2. Link to ticket
  const response = await client.post<Ticket>(`tickets/documents/${id}`, {
    files: files.map(file => file.id)
  })
  return response.data
}